import {Component, Input, OnInit} from '@angular/core';
import {NgxDropzonePreviewComponent} from 'ngx-dropzone';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'custom-dropzone-preview',
  templateUrl: './custom-dropzone-preview.component.html',
  styleUrls: ['./custom-dropzone-preview.component.scss'],
  providers: [
    {
      provide: NgxDropzonePreviewComponent,
      useExisting: CustomDropzonePreviewComponent
    }
  ]
})
export class CustomDropzonePreviewComponent extends NgxDropzonePreviewComponent implements OnInit {
  @Input() imageSrc: string;

  constructor(
    sanitizer: DomSanitizer
  ) {
    super(sanitizer);
  }

  ngOnInit() {
  }
}